import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { GraphqlService } from '../providers/graphql.service';
import { GetQueryHandlersService } from '../providers/get-query-handlers';
import { ConstantsMessagesService } from '../providers/constants.messages';
import { CommonMethodService } from '../providers/common-method.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConstantsService } from '../providers/constants.service';
import { forkJoin } from 'rxjs';
import { CommonLoaderComponent } from './common-loader/common-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, FormsModule, ReactiveFormsModule, CommonLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{

 ngOnInit(): void {
   
 }
  

}
